import { Modal } from "@packages/ds";
import styled from "styled-components";

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 32px;
`;

export const CustomOverlay = styled(Modal.Overlay)`
  z-index: 999;
`;
